package cz.lhoracek.mapl.data.repository

import kotlin.js.Date

actual fun currentTimeMillis(): Long = Date.now().toLong()
